<footer>
  <div class="container">
    <div class="footer-main-div">
      <div class="footer-top-div">
        <a class="navbar-brand" routerLink="/" routerLinkActive="active" ariaCurrentWhenActive="page"><img src="assets/logo-full.svg" /></a>
<!--        <span class="text-muted">© 2023 Akl Bayti, Inc</span>-->

      </div>

      <div class="footer-middle-div">
        <div class="footer-left-div">
          <ul class="list-unstyled horizontal-list">
            <!-- <li class="ms-3"><a class="text-muted" href="#"><svg class="bi" width="24" height="24"><use xlink:href="bootstrap-icons/fonts/twitter.svg"></use></svg></a></li> -->
            <li><a class="text-muted" routerLink="/terms-and-conditions" routerLinkActive="active" ariaCurrentWhenActive="page" i18n>Terms and Conditions</a></li>
            <li><a class="text-muted" routerLink="/privacy-policy" routerLinkActive="active" ariaCurrentWhenActive="page" i18n>Privacy Policy</a></li>
            <li><a class="text-muted" routerLink="/cookies-policy" routerLinkActive="active" ariaCurrentWhenActive="page" i18n>Cookies Policy</a></li>
          </ul>
        </div>
        <div class="footer-right-div">
          <ul class="list-unstyled horizontal-list">
            <!-- <li class="ms-3"><a class="text-muted" href="#"><svg class="bi" width="24" height="24"><use xlink:href="bootstrap-icons/fonts/twitter.svg"></use></svg></a></li> -->
            <li><a class="text-black" href="https://www.threads.net/@aklbaytimarketplace"><i class="bi-threads"></i></a></li>
            <li><a class="text-black" href="https://www.instagram.com/aklbaytimarketplace"><i class="bi-instagram"></i></a></li>
            <li><a class="text-black" href="https://www.facebook.com/aklbaytimarketplace"><i class="bi-facebook"></i></a></li>
          </ul>
        </div>
      </div>

      <div class="footer-bottom-div">
        <p i18n>Copyright &copy; 2024. All rights reserved. Akl Bayti.</p>
      </div>

    </div>
  </div>
</footer>
